/**
 * PromptSchemaFieldsEditor - JSON-tree style schema builder
 *
 * This component provides a split-view interface for building JSON schemas:
 * - Left panel: Interactive tree editor with inline controls
 * - Right panel: Live JSON schema preview
 *
 * The tree view shows fields in a code-like format with dotted connecting lines,
 * type badges, and hover actions for editing, reordering, and deletion.
 */
import PromptSchemaTreeBuilder, { generateExampleObject } from './PromptSchemaTreeBuilder';

// Re-export the tree builder as the default PromptSchemaFieldsEditor
// This maintains backward compatibility with existing imports
export { generateExampleObject };
export default PromptSchemaTreeBuilder;
